import { createSimpleCustomFieldsApi } from '../custom-fields';
import { ItemType } from '../domain';
export var createUsersApi = function (baseUrl, http) {
    var api = {
        adminSearch: function (dto) {
            return http.post("".concat(baseUrl, "/users/search/admin"), dto);
        },
        dashboardSearch: function (dto) {
            return http.post("".concat(baseUrl, "/users/dashboard/search"), dto);
        },
        agentSearch: function (dto) {
            return http.post("".concat(baseUrl, "/agents/search"), dto);
        },
        updateUser: function (dto) {
            return http.put("".concat(baseUrl, "/users/").concat(dto.userId), dto.data);
        },
        addUser: function (dto) { return http.post("".concat(baseUrl, "/users"), dto); },
        addBulkUsers: function (dto) { return http.post("".concat(baseUrl, "/users/bulk"), dto); },
        get: function (dto) { return http.get("".concat(baseUrl, "/users/").concat(dto.id)); },
        me: function () { return http.get("".concat(baseUrl, "/users/me")); },
        getAgents: function (dto) { return http.get("".concat(baseUrl, "/agents?userType=").concat(dto.userType)); },
        getBanState: function (userId) { return http.get("".concat(baseUrl, "/users/").concat(userId, "/ban")); },
        banUser: function (dto) { return http.post("".concat(baseUrl, "/users/").concat(dto.id, "/ban"), dto); },
        unbanUser: function (dto) { return http.delete("".concat(baseUrl, "/users/").concat(dto.id, "/ban")); },
        updateUsersCompany: function (dto) { return http.put("".concat(baseUrl, "/users/company"), dto); },
        setUserCompanies: function (dto) { return http.put("".concat(baseUrl, "/users/").concat(dto.userId, "/companies"), dto.data); },
        addUserNote: function (dto) { return http.post("".concat(baseUrl, "/users/").concat(dto.id, "/notes"), dto); },
        getUserNotes: function (userId) { return http.get("".concat(baseUrl, "/users/").concat(userId, "/notes")); },
        customFields: createSimpleCustomFieldsApi("".concat(baseUrl, "/users"), http, ItemType.USER),
        updateUserCustomFields: function (dto) { return http.put("".concat(baseUrl, "/users/").concat(dto.id, "/fields"), dto); },
        setUsersCompanies: function (dto) { return http.put("".concat(baseUrl, "/users/companies"), dto); },
    };
    return api;
};
//# sourceMappingURL=index.js.map